import { styled } from "@mui/material/styles";
import { Box, Grid, Link, Stack, Typography } from "@mui/material";
export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "16px !important",
  color:'#3D3D3D !important',
  fontWeight:'bold !important'
}));
